import { BottomNavigation, styled } from '@mui/material';

import { COLORS } from '../../../../configs/colors';

export const StyledBottomNavigation = styled(BottomNavigation)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background-color: ${COLORS.NavyBlue};
  z-index: 1000;

  .MuiBottomNavigationAction-root {
    color: ${COLORS.White};
    opacity: 0.7;
    min-width: auto;

    &.Mui-selected {
      color: ${COLORS.White};
      opacity: 1;
    }

    .MuiBottomNavigationAction-label {
      font-size: 12px;
      margin-top: 4px;

      &.Mui-selected {
        font-size: 12px;
      }
    }
  }
`;
